<template>
  <SensorIssuesErrorView v-if="fetchError" />
  <SensorIssuesLoadingView v-else-if="fetchLoading" />
  <SensorIssuesEmptyView v-else-if="emptyIssues" />
  <SensorIssuesSuccessView v-else />
</template>





<script>
import { mapState, mapGetters } from "vuex";
import SensorIssuesSuccessView from "./SuccessView.vue";
import SensorIssuesLoadingView from "./LoadingView.vue";
import SensorIssuesErrorView from "./ErrorView.vue";
import SensorIssuesEmptyView from "./EmptyView.vue";

export default {
  name: "SensorIssuesView",
  computed: {
    ...mapState("sensorIssues", ["fetchLoading", "fetchError"]),
    ...mapGetters("sensorIssues", ["fetchRequestFailed", "emptyIssues"]),
  },
  components: {
    SensorIssuesSuccessView,
    SensorIssuesLoadingView,
    SensorIssuesErrorView,
    SensorIssuesEmptyView,
  },
};
</script>
